import React from "react";
import { motion } from "framer-motion";
import Pano from "./Pano.js";

function MoreInfoBox(props) {
  const { gameData, itemShownInInfoBox, gameProcess } = props;
  const currItem = gameData[Object.keys(gameData)[itemShownInInfoBox]];
  let url = currItem["thumbnail"];
  const i18n = props.i18n;
  //if it's a streetview
 
  // const GACUrl =
  //   "https://artsandculture.google.com/asset/" + currItem["id"];

  const GACUrl = 'asset/'+currItem["id"];

  return (
    <motion.div
      className="w-100 h-100 absolute overflow-auto top-0 left-0 bg-custom-light z-5 flex flex-row-ns flex-column"
      initial={{ x: "150%", opacity: 0 }}
      animate={{ x: "0%", opacity: 1 }}
      exit={{ x: "150%", opacity: 0 }}
      transition={{
        duration: 0.5,
        ease: "easeInOut",
      }}
    >
      <div
        className={
          "w-two-thirds-ns w-100 h-100-ns relative more-info-img-container mtauto"
        }
      >
        {currItem.category === "streetview" ? (
          <div className="w-100 h-100 flex justify-center items-center">
            <div className="w-60-l w-70-m w-80 h-90">
              <div className="aspect-ratio aspect-ratio--1x1">
                <Pano thumbnailUrl={url} mapsLoaded={props.mapsLoaded} />
              </div>
            </div>
          </div>
        ) : (
          <img
            className="more-info-img w-80 h-75 cover fit-contain pointer br3"
            src={url}
            alt={currItem["title"]}
          />
        )}
      </div>
      <div className="w-third-ns w-80 center h-100-ns flex flex-column items-start mbauto">
        <div className="w-100 w-90-ns center pl2 pr2 pb0 pb4-ns pt4-ns pt0 mtauto mbauto overflow-auto">
          <button
            className={`close-btn ${props.rtl == '1' ? 'rtl' : ''}`}
            onClick={() => {
              props.hideMoreInfo();
            }}
          ></button>
          {/* If in guess mode, do not display the metadata */}
          {gameProcess == "guess" ? null : (
            <div>
              <h3 className={`mr2 ${gameProcess == "end" ? "" : "dn db-ns"}`}>
                {currItem["title"]}
              </h3>
              {currItem["author"] !== "null" ? (
                <p
                  className={`mr2 pt0 mt0 mb2 ${
                    gameProcess == "end" ? "" : "dn db-ns"
                  }`}
                >
                  {currItem["author"]}
                </p>
              ) : null}
              {currItem["date"] !== "null" ? (
                <p
                  className={`mr2 pt0 mt0 mb2 ${
                    gameProcess == "end" ? "" : "dn db-ns"
                  }`}
                >
                  {currItem["date"]}
                </p>
              ) : null}
              {currItem["partner"] !== "null" ? (
                <p
                  className={`mr2 pt0 mt0 mb2 ${
                    gameProcess == "end" ? "" : "dn db-ns"
                  }`}
                >
                  {currItem["partner"]}
                </p>
              ) : null}
              {currItem["description"] !== "null" ? (
                <p
                  className={`mr4 pt0 mt4 mb4 o-50 lh-copy measure f6 ${
                    gameProcess == "end" ? "" : "dn db-ns"
                  }`}
                >
                  {currItem["description"]}
                </p>
              ) : null}
            </div>
          )}
          <button
            className="mr2 mt2 mb0-ns mb2 secondary-btn tl"
            onClick={() => {
              props.openLink(GACUrl);
            }}
          >
            {i18n.view_gac}
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default MoreInfoBox;
